import React, { useState } from "react";
import { Row, Form, Col, FormControl, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import externalService from "../../services/external.service";
import authService from "../../services/auth.service";
const user = authService.getCurrentUser();
//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

// Create Document Component
function CheckDeed() {
  const [personcard, setPersoncard] = useState("");
  const [deed, setDeed] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setPersoncard(e.target.value);
    setDeed({});
  };

  function checkID(id) {
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  }
  const handleClick = (e) => {
    e.preventDefault();
    if (checkID(personcard)) {
      setLoading(true);
      externalService
        .getDeed({ citizenId: personcard, user_id: user.user.user_id })
        .then((res) => {
          setDeed(res.data);
        })
        .catch((err) => {
          toast.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      toast.error("เลขบัตรประชาชนไม่ถูกต้อง");
    }
  };
  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Row>
        <Col md={4}>
          <Form.Group>
            <FormControl
              placeholder="เลขบัตรประชาชน"
              type="number"
              name="person_card"
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Button
              className="btn btn-primary"
              style={{
                padding: ".375rem .75rem",
                fontSize: "1rem",
                margin: "0",
              }}
              onClick={handleClick}
            >
              ตรวจสอบ
            </Button>
          </Form.Group>
        </Col>
      </Row>
      <hr />
      <Row>
        <p>
          ทะเบียนอาคารชุด :<span>{deed.condoId}</span>
        </p>
        <p>
          ชื่ออาคารชุด :<span>{deed.condoNameTh}</span>
        </p>
        <p>
          ตารางเมตร :<span>{deed.condoroomAreaNum}</span>
        </p>
        <p>
          รายการสิ่งปลูกสร้าง :<span>{deed.constructionName}</span>
        </p>
        <p>
          วันที่ปรับปรุงข้อมูลล่าสุด :<span>{deed.lastUpdate}</span>
        </p>
        <p>
          เลขบัตรเจ้าของ :<span>{deed.ownerPid}</span>
        </p>
        <p>
          อำเภอ :<span>{deed.parcelAmphurName}</span>
        </p>
        <p>
          หมู่ :<span>{deed.parcelMoo}</span>
        </p>
        <p>
          จังหวัด :<span>{deed.parcelProvinceName}</span>
        </p>
        <p>
          จำนวนที่ดิน/ไร่ :<span>{deed.parcelRaiNum}</span>
        </p>
        <p>
          เลขหน้าสำรวจ :<span>{deed.parcelSurveyNo}</span>
        </p>
        <p>
          ตำบล :<span>{deed.parcelTambolName}</span>
        </p>
        <p>
          ประเภทเอกสารสิทธิ์ :<span>{deed.parcelTypeName}</span>
        </p>
        <p>
          เลขที่ดิน :<span>{deed.parcelUtmLandNo}</span>
        </p>
        <p>
          ระวางที่ตั้งที่ดิน :<span>{deed.parcelUtmMap}</span>
        </p>
        <p>
          เลขระวาง :<span>{deed.parcelWaNum}</span>
        </p>
        <p>
          เลขที่เอกสารสิทธิ์ :<span>{deed.propertyNo}</span>
        </p>
      </Row>
    </>
  );
}
export default CheckDeed;
